// Captures and persists referral attribution from `?ref=<user_id>` query params.
// The first ref a visitor sees wins (Airbnb / Uber convention) and is valid for 30 days.

const STORAGE_KEY = "afm_ref";
const TTL_DAYS = 30;

export const captureRefFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref) return;
    const current = getStoredRef();
    if (current && current.ref === ref) return; // already same
    if (current && current.ref !== ref) {
      // Don't overwrite an existing attribution unless it's expired
      if (Date.now() - current.at < TTL_DAYS * 24 * 60 * 60 * 1000) return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ref, at: Date.now() }));
  } catch { /* ignore */ }
};

export const getStoredRef = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.ref || !parsed?.at) return null;
    if (Date.now() - parsed.at > TTL_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch { return null; }
};

export const getRefForCheckout = () => getStoredRef()?.ref || null;

export const appendRefToUrl = (url, refCode) => {
  if (!refCode) return url;
  try {
    const u = new URL(url, window.location.origin);
    if (!u.searchParams.has("ref")) u.searchParams.set("ref", refCode);
    return u.toString();
  } catch {
    return `${url}${url.includes("?") ? "&" : "?"}ref=${encodeURIComponent(refCode)}`;
  }
};
